type ScheduleGtmContentArgs = {
  scheduleId: number;
  location: string;
};

export const buildScheduleGtmContent = ({
  scheduleId,
  location,
}: ScheduleGtmContentArgs): string =>
  JSON.stringify({
    schedule_id: scheduleId,
    location,
  });
